/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Stored_As_UtcInputs */

const en_orders_stored_as_utc = /** @type {(inputs: Orders_Stored_As_UtcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stored as UTC epoch milliseconds.`)
};

const es_orders_stored_as_utc = /** @type {(inputs: Orders_Stored_As_UtcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se guarda como milisegundos epoch UTC.`)
};

/**
* | output |
* | --- |
* | "Stored as UTC epoch milliseconds." |
*
* @param {Orders_Stored_As_UtcInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_stored_as_utc = /** @type {((inputs?: Orders_Stored_As_UtcInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Stored_As_UtcInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_stored_as_utc(inputs)
	return es_orders_stored_as_utc(inputs)
});